export default __webpack_public_path__ + "app/images/theme-images/light/screenshot-btn-disabled/icon-20-screenshot@2x.webp";